export enum ToggleState {
	expanded = 'expanded',
	collapsed = 'collapsed',
}
